export const QC_PASS_FAIL_MODAL_CONTEXT_NAME = 'modalQCPassFailOpen';
export const SPECIAL_INSTRUCTIONS_ATTACHMENT_FIELD_NAME =
  'special_instructions_attachment';
